import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import lottie from "lottie-web";




const Lottie = forwardRef(
    ({ animation, loop = true, speed = 1, autoPlay = false, heightLottie }, ref) => {
        const containerRef = useRef(null);
        const animRef = useRef(null);
        const resizeRafRef = useRef(0);





        /**
        * Init lottie and start automatically animation if autoPlay
        *
        * @param {ref} containerRef - Container of lottie
        * @param {object} animation - Animation json
        * @param {bool} loop - State loop
        * @param {bool} autoPlay - State autoPlay
        * @param {ref} animRef - Lottie animation
        * @returns {void}
        */
        useEffect(() => {
            const anim = lottie.loadAnimation({
                container: containerRef.current,
                renderer: "svg",
                loop,
                autoplay: false,
                path: typeof animation === "string" ? animation : undefined,
                animationData: typeof animation === "object" ? animation : undefined
            });
            animRef.current = anim;

            const initAndMaybeStart = () => {
                anim.setSpeed(speed);
                anim.setLoop(loop);
                anim.goToAndStop(0, true);
                cancelAnimationFrame(resizeRafRef.current);
                resizeRafRef.current = requestAnimationFrame(() => {
                    const a = animRef.current;
                    if (a && a === anim && a.renderer && containerRef.current && containerRef.current.isConnected) {
                        try { a.resize(); }
                        // eslint-disable-next-line no-unused-vars, no-empty
                        catch (e) {}
                    }
                });


                if (autoPlay) {
                    // Start automatically
                    anim.goToAndPlay(0, true);
                }
            };

            // If animation is ready immediatly (animationData objet)
            if (anim.isLoaded) {
                initAndMaybeStart();
            }
            else {
                const onReady = () => {
                    anim.removeEventListener("data_ready", onReady);
                    anim.removeEventListener("DOMLoaded", onReady);
                    initAndMaybeStart();
                };
                anim.addEventListener("data_ready", onReady);
                anim.addEventListener("DOMLoaded", onReady);
            }

            return () => {
                cancelAnimationFrame(resizeRafRef.current);
                anim.destroy();
                animRef.current = null;
            };
        }, [animation, loop, speed, autoPlay]);




        /**
        * Start lottie animation manually
        *
        * @param {ref} animRef - Lottie animation
        * @returns {void}
        */
        const startLottie = () => {
            const anim = animRef.current;
            if (!anim) {return;}
            if (anim.isLoaded) {
                anim.setLoop(loop);
                anim.goToAndPlay(0, true);
            }
            else {
                const h = () => {
                    anim.removeEventListener("data_ready", h);
                    anim.removeEventListener("DOMLoaded", h);
                    anim.setLoop(loop);
                    anim.goToAndPlay(0, true);
                };
                anim.addEventListener("data_ready", h);
                anim.addEventListener("DOMLoaded", h);
            }
        };




        /**
        * Stop lottie animation
        *
        * @param {ref} animRef - Lottie animation
        * @returns {void}
        */
        const stopLottie = ({ freezeAtFrame = 0 } = {}) => {
            const anim = animRef.current;
            if (!anim) {return;}
            if (freezeAtFrame == null) {
                anim.stop(); // reset à 0
            }
            else {
                anim.goToAndStop(freezeAtFrame, true); // gèle sur une frame
            }
        };




        /**
        * For use function startLottie & stopLottie outside this component with ref
        *
        * @param {function} startLottie - Start lottie animation
        * @param {function} stopLottie - top lottie animation
        * @returns {void}
        */
        useImperativeHandle(ref, () => ({ startLottie, stopLottie }));




        return (
            <div
                ref={containerRef}
                style={{ width: "100%", height: heightLottie ? heightLottie : "100%", position: "relative" }}
            />
        );
    }
);

export default Lottie;
